/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type { MarkTreatmentPlanAsReadErrorResponse } from './api.schemas';

import { api } from '../util/http';

export const markTreatmentPlanAsRead = (encounterId: number, signal?: AbortSignal) => {
  return api<void>({
    url: `/api/encounters/${encounterId}/treatmentplan/mark-as-read`,
    method: 'POST',
    signal,
  });
};

export const getMarkTreatmentPlanAsReadMutationOptions = <
  TError = MarkTreatmentPlanAsReadErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markTreatmentPlanAsRead>>,
    TError,
    { encounterId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markTreatmentPlanAsRead>>,
  TError,
  { encounterId: number },
  TContext
> => {
  const mutationKey = ['markTreatmentPlanAsRead'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markTreatmentPlanAsRead>>,
    { encounterId: number }
  > = (props) => {
    const { encounterId } = props ?? {};

    return markTreatmentPlanAsRead(encounterId);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkTreatmentPlanAsReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof markTreatmentPlanAsRead>>
>;

export type MarkTreatmentPlanAsReadMutationError = MarkTreatmentPlanAsReadErrorResponse;

export const useMarkTreatmentPlanAsRead = <
  TError = MarkTreatmentPlanAsReadErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof markTreatmentPlanAsRead>>,
      TError,
      { encounterId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof markTreatmentPlanAsRead>>,
  TError,
  { encounterId: number },
  TContext
> => {
  const mutationOptions = getMarkTreatmentPlanAsReadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
